import { BroadcastChannel } from 'broadcast-channel';
import { t } from 'i18next';
import { toast } from 'react-toastify';
import { authService } from './service/authApi';
import { getAccessToken, setAccessToken, setLegacyContext } from './service/authRuntime';
import { signOutFirebase } from './service/firebaseBridge';
import { clearPersistedUserSessionData } from './service/userSessionCache';
import { resetMatomoUserId } from './helpers/matomo';

const logoutChannel = new BroadcastChannel('logout');
const logoutToastId = 'logout-in-progress';

const showLogoutToast = async () => {
  toast.info(t('custom.saindo'), {
    position: 'bottom-right',
    autoClose: false,
    closeOnClick: false,
    toastId: logoutToastId,
  });

  await new Promise<void>((resolve) => {
    window.setTimeout(resolve, 350);
  });
};

const clearLocalState = async () => {
  await signOutFirebase().catch(() => undefined);
  setAccessToken(null);
  setLegacyContext(null);
  clearPersistedUserSessionData();
  resetMatomoUserId();
};

export const logout = async () => {
  const token = getAccessToken();

  await showLogoutToast();

  if (!token) {
    toast.dismiss(logoutToastId);
    toast.error(t('apiErrors.genericError'), { toastId: 'logout-failed' });
    return;
  }

  try {
    await authService.logout(token);
    await clearLocalState();
    await logoutChannel.postMessage('logout');
    window.location.assign('/login');
  } catch {
    toast.dismiss(logoutToastId);
    toast.error(t('apiErrors.genericError'), { toastId: 'logout-failed' });
    return;
  }
};

export const logoutAllTabs = () => {
  logoutChannel.onmessage = async () => {
    await showLogoutToast();
    await clearLocalState();
    window.location.assign('/login');
  };
};
